import React, {Component} from 'react';
import {connect} from 'react-redux';

import {Container} from "reactstrap";

import PaymentMethod from './PaymentMethod';
import PaymentHistory from './PaymentHistory';

class TenantBillingContainer extends Component {
    render() {
        return (
            <Container>
                <PaymentMethod/>
                <PaymentHistory/>
            </Container>
        );
    }
}

export default connect()(TenantBillingContainer);


// WEBPACK FOOTER //
// ./src/containers/tenant/billing/TenantBillingContainer.js